/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {BundleSettlementsDetailComponent} from './bundle-settlements-detail.component';
import {TableModule} from '../../shared/table/table.module';
import {InputModule} from '../../shared/input/input.module';
import {PipesModule} from '../../shared/pipes/pipes.module';
import {TooltipModule} from '../../shared/tooltip/tooltip.module';
import {FlyingMenuModule} from '../../shared/flying-menu/flying-menu.module';
import {CommonModule} from '@angular/common';

@NgModule({
    exports: [BundleSettlementsDetailComponent],
    imports: [TableModule, InputModule, PipesModule, TooltipModule, FlyingMenuModule, CommonModule],
    declarations: [BundleSettlementsDetailComponent]
})
export class BundleSettlementsDetailModule {
}
